import { verifyUserPassword } from '../services/userService'

function fetchVerifyUserPassword(password) {
  return verifyUserPassword({
    password
  })
}

export default fetchVerifyUserPassword



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchVerifyUserPassword.js